import { useState } from "react";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

function EditAccountModal({ account, onClose }) {
  const [formData, setFormData] = useState({
    acc_name: account.acc_name,
    acc_number: account.acc_number,
    ifsc_code: account.ifsc_code,
    branch: account.branch,
    bank_name: account.bank_name,
    signing_authority: account.signing_authority,
    acc_limit: account.acc_limit,
    acc_type: account.acc_type,
    contact_no: account.contact_no
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const accessToken = localStorage.getItem("access_token");

    fetch(getApiUrl(`/PartnerFiles/account-details/${account.id}/`), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to update account details");
        }
        alert("Account details updated successfully!");
        onClose();
      })
      .catch((error) =>
        console.error("Error updating account details:", error)
      );
  };

  return (
    <div
      className="fixed inset-0 flex justify-center items-center z-50"
      id="marketingmodalopen"
      style={{ width: "100vw", height: "100vh" }}
    >
      {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"></div> */}
      <div
        className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
        style={{
          width: "100vw",
          height: "150%",
          background: "black",
          backgroundSize: "200% 200vh",
          overflowY: "hidden",
          paddingBottom: "150px",
        }}
      ></div>
      {/* <div className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg" style={{ marginTop: "100px" }}> */}
      <div
        className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg"
        style={{
          // marginTop: "50px",
          height: "95vh", // Set height to allow scrolling
          overflowY: "auto", // Enable scrolling inside modal
        }}
      >
        <div
          className="overflow-auto max-h-[80vh]"
          style={{ padding: "100px", paddingTop: "20px" }}
        >
          <h2 className="text-center text-blue-700 mb-5">
            Edit Account Detail
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-red-700 transition-colors"
            style={{ position: "absolute", top: "20px", right: "20px" }}
          >
            X
          </button>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1">
              <label
                htmlFor="acc_name"
                className="block text-sm font-medium text-gray-700"
              >
                Account Name
              </label>
              <input
                id="acc_name"
                type="text"
                name="acc_name"
                value={formData.acc_name}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-1">
              <label
                htmlFor="acc_number"
                className="block text-sm font-medium text-gray-700"
              >
                Account Number
              </label>
              <input
                id="acc_number"
                type="text"
                name="acc_number"
                value={formData.acc_number}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1">
                <label
                  htmlFor="ifsc_code"
                  className="block text-sm font-medium text-gray-700"
                >
                  IFSC Code
                </label>
                <input
                  id="ifsc_code"
                  type="text"
                  name="ifsc_code"
                  value={formData.ifsc_code}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="space-y-1">
                <label
                  htmlFor="branch"
                  className="block text-sm font-medium text-gray-700"
                >
                  Branch
                </label>
                <input
                  id="branch"
                  type="text"
                  name="branch"
                  value={formData.branch}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="space-y-1">
              <label
                htmlFor="bank_name"
                className="block text-sm font-medium text-gray-700"
              >
                Bank Name
              </label>
              <input
                id="bank_name"
                type="text"
                name="bank_name"
                value={formData.bank_name}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="space-y-1">
              <label
                htmlFor="signing_authority"
                className="block text-sm font-medium text-gray-700"
              >
                Signing Authority
              </label>
              <input
                id="signing_authority"
                type="text"
                name="signing_authority"
                value={formData.signing_authority}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1">
                <label
                  htmlFor="acc_limit"
                  className="block text-sm font-medium text-gray-700"
                >
                  Account Limit
                </label>
                <input
                  id="acc_limit"
                  type="text"
                  name="acc_limit"
                  value={formData.acc_limit}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="space-y-1">
                <label
                  htmlFor="acc_type"
                  className="block text-sm font-medium text-gray-700"
                >
                  Account Type
                </label>
                <input
                  id="acc_type"
                  type="text"
                  name="acc_type"
                  value={formData.acc_type}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div className="space-y-1">
                <label
                  htmlFor="acc_type"
                  className="block text-sm font-medium text-gray-700"
                >
                  Contact Number
                </label>
                <input
                  id="contact_no"
                  type="text"
                  name="contact_no"
                  value={formData.contact_no}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditAccountModal;
